import type { FC, ButtonHTMLAttributes } from 'react';
import { Spinner } from './Spinner';

type LoadingButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  isLoading: boolean;
  children: React.ReactNode;
};

export const LoadingButton: FC<LoadingButtonProps> = ({ 
  isLoading, 
  children, 
  className = '', 
  disabled,
  ...props 
}) => {
  return (
    <button
      className={`button button--block button--primary grid self-end h-12 flex-center relative cursor-pointer ${className}`}
      disabled={disabled || isLoading}
      {...props}
    >
      {isLoading ? (
        <Spinner className="h-4 w-4 text-white z-10" />
      ) : (
        children
      )}
    </button>
  );
};
